export default function ieVersion() {
  let ie = 0;
  try {
    ie = navigator.userAgent.match(/(MSIE |Trident.*rv[ :])([0-9]+)/)[2];
  } catch (e) {}
  return ie;
}
